// extracted by mini-css-extract-plugin
module.exports = {"SliderArrow":"styles_SliderArrow__JRMvY","icon":"styles_icon__3uGNa","right":"styles_right__1TWTd","disabled":"styles_disabled__2DZWN"};